import { render, staticRenderFns } from "./TopicsGrid.vue?vue&type=template&id=50b2cd06"
import script from "./TopicsGrid.vue?vue&type=script&lang=js"
export * from "./TopicsGrid.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports